import { SvgIconComponent } from '@cp/ds/src/components/svgIcon';
// import { MicrophoneIcon } from '@cp/ds/src/icons/microphone';
import { PlayIcon } from '@cp/ds/src/icons/play';
import { AttachmentType } from '@common/model/resource/attachment/type';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { AttachmentViewModel } from '@common/model/resource/attachment/viewModel';

export const useCatalogItemMedia = (
  data: CatalogItemViewModel,
): { media: AttachmentViewModel | undefined; icon: SvgIconComponent | undefined } => {
  const iconComponentVariant = {
    [AttachmentType.Audio]: PlayIcon, // MicrophoneIcon,
    [AttachmentType.Video]: PlayIcon,
  };

  const media = data.media.find(({ type: attachmentType }) => AttachmentType.Audio === Number(attachmentType));

  return {
    media,
    icon: media && iconComponentVariant[media.type],
  };
};
